<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade"
    id="musrufypay-modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content shadow-lg rounded-3 border-0">
        <!-- Header -->
        <div
          class="modal-header bg-primary text-white d-flex justify-content-between align-items-center"
        >
          <h5
            style="font-weight: 700 !important"
            class="modal-title fw-bold text-white"
          >
            مصرفي باي | MusrufyPay
          </h5>
          <button
            type="button"
            class="btn btn-light btn-sm"
            style="border-radius: 50px"
            data-bs-dismiss="modal"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body p-4">
          <!-- Logo -->
          <div class="text-center mb-3">
            <img
              class="img-fluid mb-2"
              src="assets/img/MasrefyPay.png"
              alt="MusrufyPay"
              style="max-height: 80px"
            />
          </div>

          <!-- STEP 1: Payment Info -->
          <div v-if="step === 1">
            <div class="card border-0 shadow-sm rounded-3">
              <div class="card-body">
                <h5 class="mb-3 text-center fw-bold text-primary">
                  أدخل بيانات الدفع
                </h5>
                <form @submit.prevent="handleCharge" class="form-horizontal">
                  <div class="form-group mb-3">
                    <label for="identity" class="fw-semibold mb-1"
                      >رقم البطاقة</label
                    >
                    <input
                      type="text"
                      class="form-control text-center rounded-pill"
                      id="identity"
                      v-model="identity_card"
                      placeholder="أدخل رقم البطاقة"
                    />
                  </div>

                  <div class="form-group mb-3">
                    <label for="amount" class="fw-semibold mb-1">المبلغ</label>
                    <input
                      type="number"
                      class="form-control text-center rounded-pill"
                      id="amount"
                      v-model="amount"
                      placeholder="أدخل المبلغ"
                    />
                  </div>

                  <button
                    class="btn btn-primary w-100 rounded-pill fw-bold py-2"
                    type="submit"
                    :disabled="isLoading"
                  >
                    متابعة <i class="fa fa-arrow-left ms-2"></i>
                    <span
                      v-if="isLoading"
                      class="spinner-border spinner-border-sm"
                    ></span>
                  </button>
                </form>
              </div>
            </div>
          </div>

          <!-- STEP 2: OTP -->
          <div v-if="step === 2">
            <div class="card border-0 shadow-sm rounded-3">
              <div class="card-body">
                <h5 class="mb-3 text-center fw-bold text-primary">
                  أدخل رمز التحقق (OTP)
                </h5>
                <form @submit.prevent="handleComplete" class="form-horizontal">
                  <div class="form-group mb-3">
                    <label for="otp" class="fw-semibold mb-1">رمز OTP</label>
                    <input
                      type="text"
                      class="form-control text-center rounded-pill"
                      id="otp"
                      v-model="otp"
                      placeholder="أدخل رمز OTP المرسل"
                    />
                  </div>

                  <div class="d-flex justify-content-between">
                    <!-- زر الرجوع -->
                    <button
                      type="button"
                      class="btn btn-outline-secondary rounded-pill fw-bold px-4"
                      @click="goBack"
                      :disabled="isLoading"
                    >
                      <i class="fa fa-arrow-right me-2"></i> رجوع
                    </button>

                    <!-- زر التأكيد -->
                    <button
                      class="btn btn-primary rounded-pill fw-bold px-4"
                      type="submit"
                      :disabled="isLoading"
                    >
                      تأكيد الدفع <i class="fa fa-check-circle ms-2"></i>
                      <span
                        v-if="isLoading"
                        class="spinner-border spinner-border-sm"
                      ></span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- End Body -->
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";

export default {
  name: "MusrufyPay",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      step: 1, // 1 = charge, 2 = otp
      identity_card: "",
      amount: "",
      otp: "",
      transaction_id: null,
      isLoading: false,
    };
  },
  mounted() {
    // إعادة التهيئة عند إغلاق المودال
    const modal = document.getElementById("musrufypay-modal");
    modal.addEventListener("hidden.bs.modal", () => {
      this.resetModal();
    });
  },
  methods: {
    resetModal() {
      this.step = 1;
      this.identity_card = "";
      this.amount = "";
      this.otp = "";
      this.transaction_id = null;
      this.isLoading = false;
    },
    goBack() {
      this.step = 1;
      this.otp = "";
    },
    async handleCharge() {
      try {
        this.isLoading = true;

        const response = await fetch(`${apiUrl}/payment/charge`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
            "x-country-code": window.appRegion.phone_code,
          },
          body: JSON.stringify({
            payment_method: "musrufypay",
            identity_card: this.identity_card,
            amount: this.amount,
          }),
        });

        const data = await response.json();

        if (!response.ok) throw data;

        this.transaction_id = data.data.transaction_id;
        this.step = 2; // go to OTP step

        Swal.fire("تمت العملية", "الرجاء إدخال رمز OTP المرسل لك", "info");
      } catch (error) {
        Swal.fire("خطأ", error.error || "تعذر إتمام العملية", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async handleComplete() {
      try {
        this.isLoading = true;

        const response = await fetch(`${apiUrl}/payment/complete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify({
            transaction_id: this.transaction_id,
            otp: this.otp,
            payment_method: "musrufypay",
          }),
        });

        const data = await response.json();

        if (!response.ok) throw data;

        Swal.fire("نجاح", "تم الدفع بنجاح", "success").then(() => {
          location.reload();
        });
      } catch (error) {
        Swal.fire("خطأ", error.error || "فشل التحقق من OTP", "error");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
/* تحسين الحقول */
#identity,
#amount,
#otp {
  background: #f9f9f9;
  border: 1px solid #ddd;
  transition: all 0.3s ease-in-out;
}

#identity:focus,
#amount:focus,
#otp:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 6px rgba(13, 110, 253, 0.3);
  background: #fff;
}

/* الأزرار */
.btn-primary {
  font-size: 15px;
  letter-spacing: 0.5px;
}

.modal-content {
  border-radius: 1rem;
  overflow: hidden;
}
</style>
